/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICursorPagination } from './APICursorPagination';
import {
    APICursorPaginationFromJSON,
    APICursorPaginationFromJSONTyped,
    APICursorPaginationToJSON,
    APICursorPaginationToJSONTyped,
} from './APICursorPagination';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
    APIPaginationToJSONTyped,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIMeta
 */
export interface APIMeta {
    /**
     * 
     * @type {APIPagination}
     * @memberof APIMeta
     */
    pagination?: APIPagination;
    /**
     * 
     * @type {APICursorPagination}
     * @memberof APIMeta
     */
    cursor_pagination?: APICursorPagination;
}

/**
 * Check if a given object implements the APIMeta interface.
 */
export function instanceOfAPIMeta(value: object): value is APIMeta {
    return true;
}

export function APIMetaFromJSON(json: any): APIMeta {
    return APIMetaFromJSONTyped(json, false);
}

export function APIMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': json['pagination'] == null ? undefined : APIPaginationFromJSON(json['pagination']),
        'cursor_pagination': json['cursor_pagination'] == null ? undefined : APICursorPaginationFromJSON(json['cursor_pagination']),
    };
}

export function APIMetaToJSON(json: any): APIMeta {
    return APIMetaToJSONTyped(json, false);
}

export function APIMetaToJSONTyped(value?: APIMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': APIPaginationToJSON(value['pagination']),
        'cursor_pagination': APICursorPaginationToJSON(value['cursor_pagination']),
    };
}

